import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';

import './GridBannerInternalAdvCell.css';
import * as keyset from './GridBannerInternalAdvCell.i18n';

const i18n = i18nFactory(keyset);

export interface GridBannerInternalAdvCellProps {
    id: string;
    title: string;
}

const block = 'grid-banner-internal-adv-cell';

export class GridBannerInternalAdvCell extends React.PureComponent<GridBannerInternalAdvCellProps> {
    render() {
        const { id, title } = this.props;

        return (
            <div className={Bem.cls(block)}>
                <div className={Bem.cls(block, 'info')}>
                    <div className={Bem.cls(block, 'name')}>{title}</div>
                    <div className={Bem.cls(block, 'id')}>{i18n('banner-id', { bannerId: id })}</div>
                </div>
            </div>
        );
    }
}
